import { NextResponse } from 'next/server'
import { query, queryOne } from '@/lib/db'

// Rouvrir la caisse
export async function DELETE(req: Request) {
  const { caisse_session_id } = await req.json()
  if (!caisse_session_id) return NextResponse.json({ error: 'Session manquante' }, { status: 400 })
  await query(
    'UPDATE caisse_sessions SET statut = ?, ferme_a = NULL, solde_reel = NULL, note_fermeture = NULL WHERE id = ?',
    ['ouverte', caisse_session_id]
  )
  return NextResponse.json({ ok: true })
}

export async function POST(req: Request) {
  const { caisse_session_id, solde_reel, note } = await req.json()
  if (!caisse_session_id) {
    return NextResponse.json({ error: 'Session manquante' }, { status: 400 })
  }

  await query(
    'UPDATE caisse_sessions SET statut = ?, ferme_a = NOW(), solde_reel = ?, note_fermeture = ? WHERE id = ?',
    ['fermee', solde_reel ?? null, note ?? null, caisse_session_id]
  )

  const session = await queryOne('SELECT * FROM caisse_sessions WHERE id = ?', [caisse_session_id])
  return NextResponse.json({ ok: true, session })
}
